import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useState, useEffect, isValidElement, Children, useContext, } from "react";
import { Key } from "ts-key-enum";
export const TabsContext = createContext({
    ids: [],
    selectedId: null,
    setSelectedId: () => { },
    setFocusedId: () => { },
    handleClick: () => { },
    handleKeyDown: () => { },
    isNavigation: false,
});
export const TabsProvider = ({ onChange, selectedId: externalSelectedId = null, children, isNavigation = false, }) => {
    const ids = Children.map(children, (child) => {
        if (isValidElement(child)) {
            const tab = child.props;
            return isNavigation ? tab.href : tab.id;
        }
        return null;
    }) || [];
    const [selectedId, setSelectedId] = useState(externalSelectedId);
    const [focusedId, setFocusedId] = useState(null);
    const handleKeyDown = (event) => {
        if (event.key === Key.ArrowLeft || event.key === Key.ArrowRight) {
            event.preventDefault();
            const currentFocusIndex = ids.findIndex((id) => id === focusedId);
            const nextFocusIndex = event.key === Key.ArrowLeft
                ? (currentFocusIndex - 1 + ids.length) % ids.length
                : (currentFocusIndex + 1) % ids.length;
            setFocusedId(ids[nextFocusIndex]);
        }
        if (event.key === Key.Home) {
            setFocusedId(ids[0]);
        }
        if (event.key === Key.End) {
            setFocusedId(ids[ids.length - 1]);
        }
        if (event.key === Key.Enter || event.key === " ") {
            setSelectedId(focusedId);
            onChange === null || onChange === void 0 ? void 0 : onChange(focusedId);
        }
    };
    const handleClick = (tabId) => {
        setSelectedId(tabId);
        onChange === null || onChange === void 0 ? void 0 : onChange(tabId);
    };
    useEffect(() => {
        if (externalSelectedId !== selectedId)
            setSelectedId(externalSelectedId);
    }, [externalSelectedId]);
    const value = {
        ids,
        focusedId,
        selectedId,
        setSelectedId,
        setFocusedId,
        handleKeyDown,
        handleClick,
        isNavigation,
    };
    return _jsx(TabsContext.Provider, { value: value, children: children });
};
export const useTabsContext = () => useContext(TabsContext);
//# sourceMappingURL=TabsProvider.js.map